export const BAD_FIVE9_VERSION_MESSAGE =
  'Your Domain is on a Five9 product version that may cause complications during migration. It is recommended to ensure your Domain is on the latest versions.';
